import { createEntityAdapter, EntityAdapter, EntityState } from '@ngrx/entity';
import { Action, createReducer, on } from '@ngrx/store';

import { Bar } from 'src/app/models/bar';
import * as barActions from './bars.actions';

export interface BarState extends EntityState<Bar> {
  selectedBar: Bar;
}

export const barAdapter: EntityAdapter<Bar> = createEntityAdapter<Bar>({});

export const initialBarState: BarState = barAdapter.getInitialState({
  selectedBar: null,
});

export const reducer = createReducer(
  initialBarState,
  on(barActions.getBars, (state, { bars }) => {
    return barAdapter.setAll(bars, {
      ...state,
    });
  }),
  on(barActions.setSelectedBar, (state, { selectedBar }) => {
    return {
      ...state,
      selectedBar,
    };
  }),
  on(barActions.deleteBarSuccess, (state, { deletedBar }) => {
    return barAdapter.removeOne(deletedBar.id, {
      ...state,
      selectedBar: null,
    });
  })
);

export function BarReducer(state: BarState | undefined, action: Action) {
  return reducer(state, action);
}

export const { selectIds, selectEntities, selectAll, selectTotal } = barAdapter.getSelectors();
